import { ProductAction } from "features/product/types/actions.product";
import { ProductTable } from "features/product/types/subproductTable";
import firebase from "firebase/app";
import "firebase/firestore";

import { AppThunk } from "services/redux/rootReducer";
import { Product } from "../../types/product";

const getProductWithUpdatedTables =
    (id: Product["id"]): AppThunk<Promise<Product>> =>
    async (dispatch, getState) => {
        const db = firebase.firestore();
        const collectionRef = db.collection("products");

        let currentProduct: Product = getState().products.find(
            (product) => product.id === id
        ) as Product;
        let tables: Product["tables"] = {};

        if (!currentProduct) throw new Error("Product not found in state");

        // Get only table for the current product
        const subCollectionRef = collectionRef.doc(id).collection("tables");

        const tableSnapshot = await subCollectionRef.get();

        tableSnapshot.docs
            .filter((tableDoc) =>
                currentProduct.tableIds.includes(tableDoc.data().id)
            )
            .forEach((tableDoc) => {
                const table = tableDoc.data() as ProductTable;
                tables[table.id] = table;
            });

        const updatedProduct: Product = {
            ...currentProduct,
            tables,
        };

        dispatch({
            type: ProductAction.SET_PRODUCT,
            product: updatedProduct,
        });
        return updatedProduct;
    };

export default getProductWithUpdatedTables;
